import type {
  TabsterDOMAttribute,
  UseArrowNavigationGroupOptions,
} from "@fluentui/react-tabster";
import { useArrowNavigationGroup } from "@fluentui/react-components";

export function useCommonArrowNavGroup(
  disableTab?: boolean,
  axis?: UseArrowNavigationGroupOptions["axis"]
): TabsterDOMAttribute {
  return useArrowNavigationGroup({
    circular: true,
    axis: axis ?? "horizontal",
    memorizeCurrent: true,
    ignoreDefaultKeydown: disableTab ? { Tab: true } : {},
  });
}
